// extracted by mini-css-extract-plugin
export default {"container":"h0-z","list":"i0-z"};